
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * StopLossType enum
 */
class StopLossType {
  /**
   * Initialize enum with a given value
   * @param {StopLossType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof StopLossType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!StopLossType}
   * @param {!StopLossType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof StopLossType)) {
      throw new TypeError('Instance of StopLossType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!StopLossType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!StopLossType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === StopLossType.NONE.value) {
      return 'NONE'
    }
    if (this.value === StopLossType.FIXED.value) {
      return 'FIXED'
    }
    if (this.value === StopLossType.TRAILING.value) {
      return 'TRAILING'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!StopLossType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!StopLossType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!StopLossType} Created enum
   */
  static fromObject (other) {
    return new StopLossType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
StopLossType.NONE = new StopLossType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
StopLossType.FIXED = new StopLossType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
StopLossType.TRAILING = new StopLossType(0 + 2)

export { StopLossType };

/**
 * Fast Binary Encoding StopLossType field model
 */
class FieldModelStopLossType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelStopLossType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelStopLossType}
   * @param {StopLossType=} defaults Default value, defaults is new StopLossType()
   * @returns {!StopLossType} Result value
   */
  get (defaults = new StopLossType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new StopLossType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelStopLossType}
   * @param {!StopLossType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelStopLossType };
